import type {Delimiter} from 'mdast'

import {MarkdownLine} from '../../../language-tools/markdown/markdown-line'

/**
 * Gets blockquote prefixes for each line in the selection
 */
export const getBlockquotePrefixesForLines = (lines: MarkdownLine[]) => {
  return lines.map(line => line.prefixes.filter(prefix => prefix.tokenType === 'blockQuotePrefix'))
}

/**
 * Determines if the selection contains any non-blockquoted lines
 */
export const hasMixedBlockquoteContent = (blockquotePrefixes: Delimiter[][]): boolean => {
  const isEmptySelection = blockquotePrefixes.length === 0
  const hasNonBlockquotedLines = blockquotePrefixes.some(prefixes => prefixes.length === 0)

  return isEmptySelection || hasNonBlockquotedLines
}
